import { render, staticRenderFns } from "./ListWidget.vue?vue&type=template&id=9c799e44&scoped=true&"
import script from "./ListWidget.vue?vue&type=script&lang=js&"
export * from "./ListWidget.vue?vue&type=script&lang=js&"
import style0 from "./ListWidget.vue?vue&type=style&index=0&id=9c799e44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c799e44",
  null
  
)

export default component.exports